import { combineReducers } from 'redux'

import emailTrackingReducer from './EmailTracking/emailTrackingReducer'

export default function emailEncryptionReducer() {
  const initialState = combineReducers({
    emailTracking: emailTrackingReducer,
  })

  return (state = initialState) => state
}
